module.exports = __webpack_public_path__ + "img/logo.09132806.png";